const versionUpdate = {
  title: 'New version available',
  message: 'A newer version has just been released. Refresh to load the latest changes.',
  reload: 'Refresh now',
  snooze: 'Later',
}

export default versionUpdate
